'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002493 from "./presto.types$$anon$93.js";
import * as $j_presto$002etypes$0024$002dIp$002dPayload$0024 from "./presto.types$-Ip-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$92(outer) {
  this.cad = null;
  this.ca5 = null;
  this.ca6 = false;
  this.cae = null;
  this.caf = false;
  this.cai = null;
  this.cab = null;
  this.cac = false;
  this.ca7 = null;
  this.ca8 = false;
  this.ca9 = null;
  this.caa = false;
  this.cag = false;
  this.cah = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.cad = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.cai = "IpPayload";
}
export { $c_Lpresto_types$Rule$$anon$92 as $c_Lpresto_types$Rule$$anon$92 };
$p = $c_Lpresto_types$Rule$$anon$92.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$92;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$92() {
}
export { $h_Lpresto_types$Rule$$anon$92 as $h_Lpresto_types$Rule$$anon$92 };
$h_Lpresto_types$Rule$$anon$92.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.cad;
});
$p.L = (function() {
  if ((!this.ca6)) {
    this.ca5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.ca6 = true;
  }
  return this.ca5;
});
$p.O = (function() {
  if ((!this.caf)) {
    this.cae = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.caf = true;
  }
  return this.cae;
});
$p.E = (function() {
  return this.cai;
});
$p.t = (function() {
  if ((!this.cac)) {
    this.cab = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ip", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cac = true;
  }
  return this.cab;
});
$p.M = (function() {
  if ((!this.ca8)) {
    this.ca7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().SM(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.ca8 = true;
  }
  return this.ca7;
});
$p.Q = (function() {
  if ((!this.caa)) {
    this.ca9 = new $j_presto$002etypes$0024$0024anon$002493.$c_Lpresto_types$$anon$93();
    this.caa = true;
  }
  return this.ca9;
});
$p.w = (function() {
  if ((!this.cah)) {
    this.cag = false;
    this.cah = true;
  }
  return this.cag;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee101) => ((p) => \u03b4scrutinee101.cGu(p)))($j_presto$002etypes$0024$002dIp$002dPayload$0024.$m_Lpresto_types$IpPayload$())));
});
var $d_Lpresto_types$Rule$$anon$92 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$92, "presto.types$Rule$$anon$92", ({
  a1c: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$92 as $d_Lpresto_types$Rule$$anon$92 };
//# sourceMappingURL=presto.types$-Rule$$anon$92.js.map
